/* eslint-disable no-console */
export const state = () => ({
  theme: 'blue',
})
export const getters = {
  theme(state) {
    let theme = ''
    switch (state.theme) {
      case 'red':
        theme = ':root { --main-color-test: #ff5e63; }'
        break
      case 'green':
        theme = ':root { --main-color-test: #36bab8; }'
        break
      case 'orange':
        theme = ':root { --main-color-test: #ff8216; }'
        break
      default:
        theme = ':root { --main-color-test: #3e4cd4; }'
    }
    return theme
  },
}
export const mutations = {
  SET_THEME: (state, theme) => {
    state.theme = theme
  },
}
export const actions = {
  setTheme({ commit }, theme) {
    commit('SET_THEME', theme)
  },
}
